// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"180":"85d5e1f7","184":"1d49171a","948":"1d49171a"}[chunkId] + ".chunk.css";
};